import { User } from 'store/types/types';

export enum UnitsOfMeasureTemplateNames {
  CANADA = 'canada',
  SI = 'si',
  IMPERIAL = 'imperial',
}

interface UserPreferences {
  unitsOfMeasureTemplateName: UnitsOfMeasureTemplateNames;
}

export enum UserRole {
  Client = 'Client',
  Employee = 'Employee',
  SupportEmployee = 'Support Employee',
  FieldViewSupportDash = 'FieldViewPlus Support Dash',
  FieldViewProxy = 'FieldViewPlus Proxy'
}

export interface UserDetails extends User {
  countryCode: string;
  id: number;
  preferences: UserPreferences;
  roles: UserRole[];
}

type BaseProperties = Record<string, number | string | boolean | undefined>;

export interface ActionProperties extends BaseProperties {
  start?: number;
  stop?: number;
  items?: number;
}


export interface HeapActionProperties extends ActionProperties {
  env: string;
  userId: string;
  app: string;
  seconds?: number;
  avgSecondsPerItem?: number;
}